import type { Ref } from 'react'
import type { LinkProps } from './Link.types'
import './Link.scss'

export function Link({
  href = '#',
  onClick,
  children,
  className = '',
  ref,
  ...rest
}: LinkProps & { ref?: Ref<HTMLAnchorElement> }) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Wenn es eine externe URL ist (http/https), im Systembrowser öffnen
    if (href.startsWith('http://') || href.startsWith('https://')) {
      e.preventDefault()
      window.api?.openExternal?.(href)
    }

    // Custom onClick Handler aufrufen falls vorhanden
    if (onClick) {
      onClick()
    }
  }

  return (
    <a
      {...rest}
      ref={ref}
      href={href}
      onClick={handleClick}
      className={`link ${className}`.trim()}
    >
      {children}
    </a>
  )
}
